export class SettingModel {
    isEnabledLoadMeta?: boolean
    saveData?: boolean

    static fromJson(json: Partial<SettingModel>): SettingModel {
        const data = Object.assign(new SettingModel(), json)
        return data
    }

    static default(): SettingModel {
        return SettingModel.fromJson({
            isEnabledLoadMeta: true,
            saveData: true,
        })
    }
}
